<script lang="ts">
  import { CarouselSize, type Page } from "$lib/gql/genCms/codegen";
  import LandingPageContent from "$lib/components/LandingPageContent/LandingPageContent.svelte";
  import RecommendationCarousel from "$lib/components/Nosto/RecommendationCarousel.svelte";
  import ExtendedFooter from "$lib/components/Footer/ExtendedFooter.svelte";
  import { page } from "$app/stores";

  import { regionStore } from "$lib/stores/region";
  import DashSocialGallery from "$lib/components/DashSocial/DashSocialGallery.svelte";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Container from "$lib/components/Container/Container.svelte";

  const regionInfo = regionStore();

  const region = $regionInfo.region;

  const language = $regionInfo.locale;

  export let pageData: Page;

  let recommendationPlacement: string;
  $: recommendationPlacement = $page?.url?.pathname.includes("/men")
    ? "frontpage-nosto-3"
    : "frontpage-nosto-2";

  let signup;

  let redealTrigger: string;

  $: signup = $page.url.searchParams.get("signup");

  switch (region) {
    case "uk":
      redealTrigger = "uk-all-weather-club";
      break;
    case "us":
      redealTrigger = "us-all-weather-club";
      break;
    case "row":
      redealTrigger = "row-all-weather-club";
      break;
    case "eu":
      redealTrigger = `eu${language}-all-weather-club`;
      break;
    case "de":
      redealTrigger = `de${language}-all-weather-club`;
      break;
    default:
      break;
  }

  $: if (signup === "true" && redealTrigger) {
    if (typeof window !== "undefined" && window.redeal) {
      window.redeal(redealTrigger);
      // setTimeout(() => {
      //   history.replaceState({}, "", $page.url.pathname);
      // }, 250);
    }
  }
</script>

<LandingPageContent {pageData} />

{#key recommendationPlacement}
  <RecommendationCarousel
    pageType="LANDING"
    input={{ placement: recommendationPlacement }}
    carouselSize={CarouselSize.Six}
  />
{/key}
<ExtendedFooter />
